import { render, staticRenderFns } from "./AdminHomeItem.vue?vue&type=template&id=04b3c7a8&scoped=true"
import script from "./AdminHomeItem.vue?vue&type=script&lang=js"
export * from "./AdminHomeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3c7a8",
  null
  
)

export default component.exports